import { render, staticRenderFns } from "./GiveRecognitionModal.vue?vue&type=template&id=62efd538&scoped=true&"
import script from "./GiveRecognitionModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./GiveRecognitionModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GiveRecognitionModal.vue?vue&type=style&index=0&id=62efd538&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62efd538",
  null
  
)

export default component.exports